import { motion, useMotionValue, transform, useTransform, useAnimationControls, useMotionValueEvent } from "framer-motion"
import styled from "@emotion/styled"

import { useProgress } from "./progressContext"
import { usePlayer } from "./context"
import { useConsole } from "contexts/Console"
import { useState } from "react"
import { useDictionary } from "contexts/Dictionary"

const Root = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
  align-self: center;
  display: flex;
  align-items: center;
`

const List = styled.ul`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: 2px;
  column-gap: 5px;
  padding: 0px;
  margin: 0px;
  width: 100%;
`

const Li = styled.li`
  display: block;
`

const Btn = styled.button`
  border: none;
  padding: 0;
  display: block;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  transition: background-color 0.3s ease 0s;
  pointer-events: all;

  .dark-theme & {
    background-color: rgba(255, 255, 255, 0.4);
  }
  .light-theme & {
    background-color: rgba(0, 0, 0, 0.3);
  }

  &::after {
    content: "";
    width: 100%;
    height: 24px;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    cursor: pointer;
  }
`

const Bar = styled(motion.div)`
  height: 100%;
  border-radius: 10px;
  background-color: white;

  .dark-theme & {
    background-color: white;
  }
  .light-theme & {
    background-color: rgb(var(--light-black));
  }

  .contrast-active & {
    background-color: black;
  }
`

function ProgBar({ slugId, index, slideNb }) {
  const console = useConsole()
  const dictionary = useDictionary()

  const { slug } = usePlayer()
  const { progressMap } = useProgress()

  const [isCurrent, setIsCurrent] = useState(slugId === slug.get())

  progressMap.set(slugId, useMotionValue(0))

  const width = useTransform(progressMap.get(slugId), p => `${p * 100}%`)

  function onClick() {
    slug.set(slugId)
  }

  function onSlug(s) {
    setIsCurrent(s === slugId)
  }
  useMotionValueEvent(slug, "change", onSlug)

  // TODO set slide word from dictionary
  return (
    <Li id={slugId}>
      <Btn onClick={onClick} aria-label={dictionary.ariaLabelSlideNumOutOf(index + 1, slideNb)} aria-current={isCurrent}>
        <Bar style={{ width }} />
      </Btn>
    </Li>
  )
}

function ProgNoBar({ slugId }) {
  const { progressMap } = useProgress()
  progressMap.set(slugId, useMotionValue(0))

  return null
}

export default function Progress() {
  const { progressMap, showProgress } = useProgress()

  return showProgress ? (
    <Root>
      <List>
        {[...progressMap].map(([slugId], i, arr) => (
          <ProgBar key={slugId} slugId={slugId} index={i} slideNb={arr.length} />
        ))}
      </List>
    </Root>
  ) : (
    [...progressMap].map(([slugId]) => <ProgNoBar key={slugId} slugId={slugId} />)
  )
}
